import React from "react";
import SectionCard from "../SectionCard/SectionCard";

function PersonalizarCookies() {
  const subtext1 = (
    <p>
      <b>Personalize </b> os seus cookies no site da empresa.
    </p>
  );
  return (
    <SectionCard
      id="Personalizarcookies"
      title="Personalizar Cookies"
      subtext1={subtext1}
      cardDetailBox
    />
  );
}

export default PersonalizarCookies;
